<template>
  <div class="container">
  
    <el-row style="margin-bottom:20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/member-center' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>投诉</el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>
      <el-form ref="form" :model="searchFormData" :inline="true" >

            <el-form-item label="">
              <el-input  placeholder="输入名称搜索" v-model="searchFormData.keyword" clearable=""></el-input>
            </el-form-item>

            <el-button type="primary" @click="search">搜索</el-button>
         
      </el-form>


      <el-table
        ref="table"
        v-loading="searchLoading"
        :data="pageProps.records"
        element-loading-text="正在查询"
        fit
        stripe
        highlight-current-row
      >

      <el-table-column align="center" label="投诉内容" prop="content"> </el-table-column>

        <el-table-column align="center" label="投诉时间"  prop="created_at"/>
        <el-table-column align="center" label="回复内容" prop="reply"> </el-table-column>
        <el-table-column align="center" label="回复时间" prop="reply_at"> </el-table-column>

        <el-table-column label="操作" fixed="right" align="center" class-name="small-padding fixed-width" width="200">
          <template slot-scope="{row}">
          
            <el-button  type="primary" size="mini" @click="edit(row.complaint_id)">
              详情
            </el-button>
        
          </template>
        </el-table-column>
    </el-table>
    <div style="text-align:center;padding:20px">
      <!--分页-->
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageProps.total"
        :page-size="pageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="pageProps.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  
</div>
</template>

<script>

import { userComplaintList} from "@/api/user/index.js";



export default {
  name: "Director-Work-Address",
  data() {
    return {
     
      searchLoading: false,
      pageProps: {
        records:[],
        total: 0,
        pageSize: 10,
        pageNum: 1
      },

      searchFormData:{
        type:1,
        keyword:"",
        page:0,
        limit:0
      }

    }
  },

  mounted() {
    this.fetchData();
  },



  methods: {

    edit(){

    },
  

    search(){
      this.fetchData();
    },

    fetchData(){
      var that = this;
      that.searchLoading=true;
      that.searchFormData.page=that.pageProps.pageNum;
      that.searchFormData.limit=that.pageProps.pageSize;

      userComplaintList(that.searchFormData).then((response) => {
        that.searchLoading=false;
        console.log(response);
        if(response.code==200){
          that.pageProps.records = response.data.data;
          that.pageProps.total = response.data.total;
        }else{
          that.$message.error(response.msg?response.msg:"请求错误");
        }
       
      });
    },

     // 当前页变更
    handleCurrentChange(num) {
      this.pageProps.pageNum = num
      this.fetchData()
    },


    // 每页显示页面数变更
    handleSizeChange(size) {
      this.pageProps.pageSize = size
      this.fetchData()
    },
    
  }
}
</script>

